import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// lightweight analytics event hook (ready for GA/CRM wiring)
export function trackEvent(name, payload = {}) {
  if (typeof window !== "undefined" && typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({ event: name, ...payload });
  }
  // eslint-disable-next-line no-console
  console.log("[track]", name, payload);
}
